<template>
    <div class="content-exports">
        <div @click="exportPreviewPdf();">
            <span class="badge-resolution">HD</span> {{ $t("planobuilder.exportPreview") }} - {{ $t("planobuilder.highDefinition") }}
        </div>
        <div @click="exportPdf();">
            <span class="badge-resolution">HD</span> {{ $t("planobuilder.exportPDF") }} - {{ $t("planobuilder.highDefinition") }}
        </div>
        <hr />
        <div @click="exportPreviewPdf('extreme');">
            <span class="badge-resolution inactive"></span> {{ $t("planobuilder.exportPreview") }} - {{ $t("planobuilder.lowDefinition") }}
        </div>
        <div @click="exportPdf('extreme');">
            <span class="badge-resolution inactive"></span> {{ $t("planobuilder.exportPDF") }} - {{ $t("planobuilder.lowDefinition") }}
        </div>
        <hr />
        <div @click="exportXls();"><span class="badge-resolution" style="background-color: green">XlS</span> {{ $t("planobuilder.exportXLS") }}</div>
    </div>
</template>

<script>
import { bus } from "../../../main";

export default {
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        exportPreviewPdf(compression = null) {
            bus.$emit("plano_exportPreviewPdf", compression);
        },
        exportPdf(compression = null) {
            bus.$emit("plano_exportPdf", compression);
        },
        exportXls() {
            bus.$emit("plano_exportXls");
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.content-exports {
    background: #fff;
    text-transform: none;
    padding: 5px 20px;
    font-size: 13px;
    hr {
        width: 70%;
        margin: 5px auto;
    }
    div {
        text-align: left;
        padding: 3px;
        cursor: pointer;
        .badge-resolution {
            display: inline-block;
            margin-right: 10px;
            border-radius: 4px;
            font-size: 12px;
            text-align: center;
            min-width: 30px;
            padding: 2px 2px;
            background-color: #a8a8a8;
            color: #fff;
            font-weight: bold;
            &.inactive {
                opacity: 0;
            }
        }
        -webkit-transition: all 0.2s linear;
        -moz-transition: all 0.2s linear;
        -ms-transition: all 0.2s linear;
        -o-transition: all 0.2s linear;
        transition: all 0.2s linear;
    }

    div:hover {
        background-color: rgba(156, 156, 156, 0.66);
    }
}
</style>



// WEBPACK FOOTER //
// Exports.vue?7920883f